/** 登录页面的请求方法 */
import http from '@/api/index'
import { Login } from '../interface/login.model'
import { PORT1 } from '../config/servicePort'

/** 登录请求 */
export class LoginServise {
  /** 获取滑块图片 */
  static getSlideImg(params?: Login.CodeImageReq) {
    return http.get<Login.CodeImageRes>(PORT1 + 'captcha/generate', params)
  }

  /** 滑块验证 */
  static toVerify(params: Login.SlideVerifyReq) {
    return http.post<Login.SlideVerifyRes>(PORT1 + 'captcha/verify', params)
  }

  /** 获取短信验证码 */
  // static getCode(params: Login.CodeMessageReq) {
  // 	return http.post<Login.CodeMessageRes>(PORT1 + "public/telCode", params);
  // }

  /** 短信登录 */
  // static codeLogin(params: Login.CodeLoginReq) {
  // 	return http.post<Login.LoginRes>(PORT1 + "public/codeLogin", params);
  // }

  /** 账密登录 目前不含验证码*/
  static paswLogin(params: Login.PaswLoginReq) {
    return http.post<Login.LoginRes>(PORT1 + 'login', params)
  }

  /**登出 */
  static logOut() {
    return http.post<Login.LoginRes>(PORT1 + 'logout')
  }
}
